import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import React from "react";
import _ from "lodash";

/**
 * Komponente zur Darstellung des Inhalts einer Tabelle
 * @param id
 * @param columns
 * @param data
 * @param visibleRows
 * @param onDoubleClick Funktion die beim Doppelklick auf eine Zeile aufgerufen wird
 * @param onAltDoubleClick Funktion die beim Doppelklick mit gedrückter Alt Taste auf eine Zeile aufgerufen wird
 * @returns {JSX.Element}
 * @constructor
 */
function EATableBody({ id, columns, data, visibleRows, onDoubleClick = null, onAltDoubleClick = null }) {
    function createCell(column, row, index) {
        if (column.componentProvider) {
            return column.componentProvider(row, index);
        }
        if (column.calculateFunction) {
            return column.calculateFunction(row, index);
        }
        return _.get(row, column.id);
    }

    return (
        <TableBody id={id}>
            {visibleRows.map((row, index) => {
                return (
                    <TableRow
                        hover
                        tabIndex={-1}
                        key={id + "-row-" + index}
                        onClick={(event) => {
                            if ((onDoubleClick || onAltDoubleClick) && event?.detail === 2) {
                                if (onAltDoubleClick && event.altKey) {
                                    onAltDoubleClick(row);
                                } else {
                                    onDoubleClick(row);
                                }
                            }
                        }}
                    >
                        {columns.map((column) => {
                            return (
                                <TableCell key={column.id} align={column.align} style={column.style}>
                                    {createCell(column, row, data ? data.indexOf(row) : 0)}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                );
            })}
        </TableBody>
    );
}

export default EATableBody;
